module.exports = __webpack_public_path__ + "static/media/HCMM632.365de959.jpg";